import { Component, Input } from '@angular/core';
import {PlusIconService } from '../plus-icon/plus-icon.service';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { AgGridService } from '../ag-grid.service';

@Component({
  selector: 'app-plus-icon',
  templateUrl: './plus-icon.component.html',
  styleUrls: ['./plus-icon.component.scss']
})
export class PlusIconComponent implements IHeaderAngularComp{
  public params: IHeaderParams;
  @Input() context: string;
  constructor(private plusIconService: PlusIconService,private agGridService : AgGridService){

  }
  agInit(params: IHeaderParams): void {
    this.params = params;
    this.context = params.column.getColId(); 
  }

  refresh(): boolean {
    return false;
  }

  onIconClick() {
    this.plusIconService.emitPlusIconClick(this.context); 
  }

  addRow(params){
    this.agGridService.appendNewRow(params)
  }
}
